import React, { useState } from "react"
import { useDispatch } from "react-redux"
import CustomModal from "../../basics/interface/CustomModal"
import InputV2 from "../../basics/input/InputV2"
import { COLORS } from "../../../utilities/Constants"
import { generalStyles as gs } from "../../styles/styles"
import { postAnnulationCommandeVirtuelle } from "../../../store/actions/atelierInventaireActions"

// GE-55 : annulation logique d'une commande virtuelle (rupture fournisseur),
// motif obligatoire — ou rétablissement (`retablir`). L'erreur serveur (article
// engagé entre-temps…) s'affiche dans la modale, qui reste ouverte.
// GE-79 : `article` → la seule ligne. `onDone` après succès (refetch du stock
// virtuel, que MAJ_COMMANDE_VIRTUELLE ne met pas à jour).
const AnnulationCommandeVirtuelleModalV2 = ({
	commande,
	article,
	retablir,
	onClose,
	onDone,
}) => {
	const dispatch = useDispatch()
	const [motif, setMotif] = useState("")
	const [envoi, setEnvoi] = useState(false)
	const [erreur, setErreur] = useState("")

	const libelle = `${commande.fournisseur_nom} · N° ${
		commande.numero_commande || commande.id
	}${article ? ` · ${article.label || article.numero}` : ""}`
	const objet = article ? "la ligne" : "la commande"
	const confirmer = () => {
		setEnvoi(true)
		setErreur("")
		dispatch(
			postAnnulationCommandeVirtuelle({
				id: commande.id,
				motif: motif.trim(),
				retablir,
				article: article ? article.id : undefined,
			}),
		).then((res) => {
			setEnvoi(false)
			if (res.ok) {
				onClose()
				if (onDone) onDone()
			} else setErreur(res.message)
		})
	}

	return (
		<CustomModal
			title={retablir ? `Rétablir ${objet} ?` : `Annuler ${objet}`}
			subtitle={libelle}
			onClose={onClose}
			buttons={[
				{ title: "Fermer", styleName: "secondary", onClick: onClose },
				{
					title: retablir ? "Rétablir" : `Annuler ${objet}`,
					styleName: retablir ? "primary" : "danger",
					onClick: confirmer,
					loading: envoi,
					disabled: envoi || (!retablir && motif.trim() === ""),
				},
			]}
		>
			{retablir ? (
				<div style={ms.texte}>
					{article ? "La ligne redevient" : "La commande redevient"}{" "}
					disponible (stock virtuel, sélection sur les fiches, export
					Excel).
					{!article &&
						(commande.all_articles || []).some(
							(a) => a.annule_le,
						) &&
						" Les lignes annulées une par une le restent."}
				</div>
			) : (
				<>
					<div style={gs.fieldRow}>
						<label style={gs.label}>
							Motif
							<span style={{ color: COLORS.danger }}> *</span>
						</label>
						<InputV2
							style={gs.input}
							value={motif}
							maxLength={200}
							autoFocus
							placeholder="Ex. rupture de stock fournisseur"
							onChange={(e) => setMotif(e.target.value)}
						/>
					</div>
				</>
			)}
			{erreur && <div style={ms.erreur}>{erreur}</div>}
		</CustomModal>
	)
}

const ms = {
	texte: { fontSize: 13, color: COLORS.textMuted, marginBottom: 12 },
	erreur: { fontSize: 13, color: COLORS.danger, marginTop: 12 },
}

export default AnnulationCommandeVirtuelleModalV2
